export default "__VITE_ASSET__df01cfea__"